
export const desktopWrapperStyle = {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    zIndex: 2147483647,
    borderRadius: '50px',
    background: 'rgb(229, 229, 229)',
    boxSizing: 'content-box',
    boxShadow: '0px 0px 30px rgba(0, 0, 0, 0.5)',
};

export const desktopClosedWrapperStyleChat = {
    position: 'fixed',
    bottom: '0px',
    right: '0px',
    zIndex: 2147483647,
    minWidth: '400px',
    boxSizing: 'content-box',
    overflow: 'hidden',
    minHeight: '120px'
};

export const mobileClosedWrapperStyle = {
    position: 'fixed',
    bottom: 18,
    right: 18,
    zIndex: 2147483647,
    borderRadius: '50%',
    background: 'rgb(229, 229, 229)',
    boxSizing: 'content-box'
};

export const mobileOpenWrapperStyle = {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 2147483647,
    width: '100%',
    height: '100%',
    background: 'rgb(229, 229, 229)',
    overflowY: 'visible',
    boxSizing: 'content-box'
};

export const desktopTitleStyle = {
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
    fontSize: '20px',
    display: 'flex',
    fontFamily: 'Lato, sans-serif',
    color: '#fff',
    background: "white"
};

export const mobileTitleStyle = {
    height: 52,
    width: 52,
    cursor: 'pointer',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    webkitBoxShadow: '1px 1px 4px rgba(101,119,134,.75)',
    boxShadow: '1px 1px 4px rgba(101,119,134,.75)'
};

export const circle = {
    display: "block",
    width: 80,
    height: 80,
    margin: "5px auto",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    borderRadius: "99em",
    border: "2px solid #fff"
};

export const agent = {
    position: "absolute",
    left: 0,
    top: -50,
    right: 0,
    margin: "auto",
    width: 101,
    height: 50,
    background: "transparent",
    zIndex: 12
};

export const agentMobile = {
    position: "absolute",
    left: 0,
    margin: "auto",
    width: 101,
    height: 50,
    background: "transparent",
    zIndex: 12
};

export const iframeRadius = {
    borderBottomLeftRadius: '20px',
    borderBottomRightRadius: '20px'
};


// WEBPACK FOOTER //
// ./src/widget/style.js